import { styled } from '@mui/material/styles';

export const SelectionBarContainerStyled = styled('div')(({ theme }) => ({
  position: 'fixed',
  margin: '0 auto',
  bottom: theme.spacing(3),
  left: 0,
  right: 0,
  zIndex: 1200,
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(1, 1.5),
  borderRadius: 999,
  backgroundColor: '#1A1A1A',
  color: theme.palette.common.white,
  border: '1px solid rgba(255, 255, 255, 0.16)',
  boxShadow: theme.shadows[8],
  width: 'fit-content',
}));
